export default function IntervalsMenu({dateRange,setDateRange}) {
  const intervalsMenu = [
    // {
    //   image: "",
    //   name: "1D",
    // },
    {
      image: "",
      name: "1W",
    },
    {
      image: "",
      name: "1M",
    },
    {
      image: "",
      name: "YTD",
    },
    {
      image: "",
      name: "1Y",
    },
    {
      image: "",
      name: "All",
    },
  ];

  return (
    <div className="intervalsMenu">
      {intervalsMenu.map((item) => {
        return (
          <span
            onClick={(e) => setDateRange(item.name)}
            className={item.name === dateRange ? "activeInterval" : ""}
            key={item.name}
          >
            {item.name}
          </span>
        );
      })}
    </div>
  );
}
